import { withIcon } from "@icons/_withIcon";

// Changelog: name was Minus
export const MinusFill = withIcon(
  () => <rect x="0" y="7.5" width="16" height="1.5" rx="0.5" />,
  {
    viewBox: "0 0 16 16",
  }
);
